import { IonText, useIonViewDidEnter } from '@ionic/react';
import React, { useState } from "react";
import SwiperCore, { Zoom, Navigation, Pagination } from 'swiper/core';
import { Swiper, SwiperSlide } from "swiper/react";
import { ISessionImage } from '../../interfaces/ISessionImage';

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/zoom/zoom.min.css"
import "swiper/components/navigation/navigation.min.css"
import "swiper/components/pagination/pagination.min.css"

import './BibleImages.scss';
import NetworkNotification from '../NetworkNotification/NetworkNotification';

SwiperCore.use([Zoom, Navigation, Pagination]);

interface IBibleImagesProps {
    images: ISessionImage[];
}

const BibleImages: React.FC<IBibleImagesProps> = (props) => {
    const [bibleImageSwiper, setBibleImageSwiper] = useState<SwiperCore | null>(null);

    useIonViewDidEnter(() => {
        bibleImageSwiper?.init();
    });

    return <div className="bible-images-root"> 
        <Swiper onSwiper={setBibleImageSwiper} zoom={true} navigation={true} className="mySwiper">
            {
                props.images && props.images.map((image, index) => 
                <SwiperSlide key={ `bibleImage-${index}` }>
                    <div className="swiper-zoom-container">
                        <img alt={image.title} src={image.url}></img>
                    </div>
                </SwiperSlide>
                )
            }
             <SwiperSlide key={ `bibleImage-100` }>
                    <div className="swiper-zoom-container">
                        <IonText color="primary"> double tap to zoom on an image...</IonText>
                    </div>
                </SwiperSlide>
        </Swiper>
        <NetworkNotification noInternetMessage="NO INTERNET CONNECTION DETECTED - Connection is required to view images."></NetworkNotification>
    </div>
};

export default BibleImages;